/* eslint-disable max-len */
// src/views/words-lists/slice/selectors.ts
import { Selector } from 'react-redux';
import { RootState } from '../../../redux/store';
import slice from './slice';
import { ApiError } from '../../../services/ApiService.types';

export const getIsLoadingWordsListList = (state: RootState) => state[slice.name]?.isLoading ?? false;

export const getListOfWordsList = (state: RootState) => state[slice.name]?.list ?? [];

export const getIsAdding = (state: RootState) => state[slice.name]?.isAdding ?? false;

export const getIsAddingError = (state: RootState) => state[slice.name]?.addingError ?? null;

export const getIsDeletingWordsList: Selector<RootState, boolean> = (state) => state[slice.name]?.isDeleting ?? false;

export const getDeletingWordsListError: Selector<RootState, ApiError | null> = (state) => state[slice.name]?.deletingError ?? null;

export const getIsLoading: Selector<RootState, boolean> = (state) => state[slice.name]?.isLoading ?? false;
